import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import EmojiPicker from 'emoji-picker-react';
import Navbar from './../navbar/navbar';
import Swal from 'sweetalert2';
import moment from 'moment';
import Rating from 'react-rating';
import DownloadDialogue from '../popup/download';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell } from '@fortawesome/free-regular-svg-icons';
import { faImages } from '@fortawesome/free-solid-svg-icons';
import { faClockRotateLeft } from '@fortawesome/free-solid-svg-icons';

const Dashboard = () => {
  const navigate = useNavigate();

  const serverHost = process.env.REACT_APP_SERVER_HOST
  const ccServerHost = process.env.REACT_APP_CC_SERVER_HOST

  const navigateTo = (path, userData = null) => {
    if (userData) {
      navigate(path, { state: { userData } });
    } else {
      navigate(path);
    }
  };

  const [user_id, setUserId] = useState(0);
  const [parent_feed, setParentFeed] = useState(null);
  const postTextAreaRef = useRef(null);
  const [avgRating, setAvgRating] = useState(0.0)

  const fetchRating = () => {
    fetch(`${serverHost}/rating`, { method: 'GET' })
      .then(response => response.json())
      .then(data => {
        setAvgRating(data.avg_rating || 0.0);
      })
      .catch(error => console.error('Error fetching rating:', error));
  };  

  useEffect(() => {
    setUserId(parseInt(sessionStorage.getItem("user_id"), 10) || 0);
    const handleAuth = () => {
      if (sessionStorage.getItem("user_id") === null) {
        console.log("Not Authenticated");
        navigate('/');
      }
    };

    handleAuth();
    
    fetchRating();

    moment.updateLocale('en', {
      relativeTime : {
          future: "in %s",
          past:   "%s ago",
          s  : 'a few seconds',
          ss : '%d s',
          m:  "1 min",
          mm: "%d mins",
          h:  "an hour",
          hh: "%d hrs",
          d:  "a day",
          dd: "%d days",
          w:  "a week",
          ww: "%d weeks",
          M:  "a month",
          MM: "%d months",
          y:  "a year",
          yy: "%d years"
      }
    });
  }, [navigate]);

  useEffect(() => {
    return () => {
      const key = 'visibleFeedIds';
      sessionStorage.removeItem(key);
    };
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();

      const text = e.target.value;
      const selectionStart = e.target.selectionStart;
      const selectionEnd = e.target.selectionEnd;
      
      const newText =
      text.substring(0, selectionStart) +
      '\n' +
      text.substring(selectionEnd);
      
      setTextareaValue(newText);
      
    }
  };  

  const [textareaValue, setTextareaValue] = useState('');
  const [waiting, setWaiting] = useState(false);
  const [isEmojiVisible, setEmojiVisibility] = useState(false);
  const [chatType, setChatType] = useState('text');
  const [imageFile, setImageFile] = useState(null);

  const Feed = ({ feed, voteFeed }) => {
    const key = 'visibleFeedIds';
    const visibleFeedIds = JSON.parse(sessionStorage.getItem(key)) || [];
    const [isVisible, setIsVisible] = useState(visibleFeedIds.includes(feed.id));

    const toggleChildren = () => {
      const updatedVisibleFeedIds = isVisible
        ? visibleFeedIds.filter(id => id !== feed.id)
        : [...visibleFeedIds, feed.id];

      setIsVisible(!isVisible); // Toggle visibility state

      sessionStorage.setItem(key, JSON.stringify(updatedVisibleFeedIds));
    };
  
    return (
      <div>
        <Post>
          <Author>
            <img src={`avatars/${feed.icon}.png`} alt="user icon" style={{ height: "40px", borderRadius: "50%" }} />
          </Author>
          <PostBody style={{ fontFamily: 'times-new-roman' }}>
            <p dangerouslySetInnerHTML={renderContent(feed.content)} />
            <Options>
              <p style={{ fontSize: "12px", margin: "0", padding: "0" }}>{moment(feed.created_at).fromNow()}</p>
              {feed.children.length ? (
                <span style={{ fontSize: "14px", fontWeight: "bold", cursor: "pointer" }} onClick={toggleChildren}>
                  {isVisible ? 'Hide' : 'View'} {feed.children.length === 1 ? 'reply' : 'replies'}
                </span>
              ) : null}
              <span style={{ fontSize: '12px', color: '#6559A2', fontWeight: 'bold', cursor: 'pointer' }} onClick={() => {
                  setParentFeed(feed);
                  if (postTextAreaRef.current)
                    postTextAreaRef.current.focus();
                }}
              >Reply</span>
            </Options>
          </PostBody>
          <Reactions>
            <i
              className="fa fa-arrow-up"
              onClick={() => voteFeed(feed.id, 1)}
              style={{ color: feed.liked_by.includes(user_id) ? "#7cfc00" : "lightgrey" }}
            />
            <span>{feed.liked_by.length - feed.disliked_by.length}</span>
            <i
              className="fa fa-arrow-down"
              onClick={() => voteFeed(feed.id, -1)}
              style={{ color: feed.disliked_by.includes(user_id) ? "red" : "lightgrey" }}
            />
          </Reactions>
        </Post>
        {isVisible && feed.children.length > 0 && (
          <Children>
            {feed.children.map((child) => (
              <Feed key={child.id} feed={child} voteFeed={voteFeed} />
            ))}
          </Children>
        )}
      </div>
    );
  };

  const addEmoji = (emojiData) => {
    const { emoji } = emojiData;
    setTextareaValue((prevValue) => prevValue + emoji);
  };

  const openCloseEmoji = () => {
    setEmojiVisibility((prevValue) => !prevValue);
  };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];

    if (!file) {
      return;
    }

    if (file) {
      try {
        const resizedDataURL = await readAndResizeImage(file);
        setImageFile(resizedDataURL);
      } catch (error) {
        console.error('Error handling image:', error);
      }
    }
  };

  const readAndResizeImage = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = 200;
          canvas.height = 200;
          const ctx = canvas.getContext('2d');
          ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear canvas
          ctx.drawImage(img, 0, 0, 200, 200); // Resize image to 200x200
          const resizedDataURL = canvas.toDataURL('image/png'); // Convert to Base64 with PNG format to maintain transparency
          resolve(resizedDataURL);
        };
        img.onerror = (error) => reject(error);
        img.src = event.target.result;
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const handleChatTypeChange = (event) => {
    setChatType(event.target.value);
  };

  const navigateChat = () => {
    navigateTo(`/chat-${chatType}`);
  };

  const [feeds, setFeeds] = useState([]);

  const location = useLocation();
  const navToSection = location.state?.navToSection;

  const [currentSection, setCurrentSection] = useState(navToSection || 2);

  const [friends, setFriends] = useState([]);

  const [activeUsersCount, setActiveUsersCount] = useState([]);

  const [isPopupVisible, setPopupVisibility] = useState(false);

  const [inviteEmail, setInviteEmail] = useState('');

  const openPopup = () => setPopupVisibility(true);
  const closePopup = () => setPopupVisibility(false);

  useEffect(() => {
    fetchFeeds();
    fetchFriends();
    fetchActiveUsers();

    const feedInterval = setInterval(fetchFeeds, 1 * 60 * 1000);
    const activeUsersInterval = setInterval(fetchActiveUsers, 1 * 60 * 1000);
    
    return () => {
      clearInterval(feedInterval);
      clearInterval(activeUsersInterval);
    };
  }, []);

  const fetchFriends = () => {
    fetch(`${serverHost}/friends?uid=${parseInt(sessionStorage.getItem("user_id"), 10)}`, { method: 'GET' })
      .then(response  => response.json())
      .then(data => {
        setFriends(data.friends);
      })
      .catch(error => console.error('Error fetching friends:', error));
  };

  const fetchActiveUsers = () => {
    fetch(`${ccServerHost}/active-users`, { method: 'GET' })
      .then(response  => response.json())
      .then(data => {
        setActiveUsersCount(data.activeUsers);
      })
      .catch(error => console.error('Error fetching active count:', error));
  };
  
  const fetchFeeds = () => {
    fetch(`${serverHost}/feeds`, { method: 'GET' })
      .then(response => response.json())
      .then(data => {
        setFeeds(data.feeds);
      })
      .catch(error => console.error('Error fetching feeds:', error));
  };

  const handleInvite = async (event) => {
    event.preventDefault();

    if (waiting || inviteEmail.trim() === '') {
      return;
    }

    setWaiting(true);

    const formData = new FormData();
    
    formData.append('username', sessionStorage.getItem("username"))
    formData.append('email', inviteEmail.trim())

    try {
      const response = await fetch(`${serverHost}/send-invite`, {
        method: 'POST',
        body: formData,
      });      
      const result = await response.json();

      if (response.status === 200) {
        Swal.fire({
          title: 'Invitation Sent',
          text: `An invitation has been sent to ${inviteEmail.trim()}`,
          icon: 'success',
          confirmButtonText: 'Close'
        });
        setInviteEmail('');
      } else {
        Swal.fire({
          title: 'Failed to send invitation',
          text: result.error,
          icon: 'error',
          confirmButtonText: 'Close'
        });
      }
    } catch (error) {
      Swal.fire({
        title: 'Failed to send invitation',
        text: error,
        icon: 'error',
        confirmButtonText: 'Close'
      });
    } finally {
      setWaiting(false);
    }
  };

  const handleFeedPost = async (event) => {
    event.preventDefault();
    setWaiting(true);

    const formData = new FormData();
     
    if (imageFile) {
      formData.append('imageFile', imageFile);
    }

    formData.append('uid', parseInt(sessionStorage.getItem("user_id"), 10))
    if (textareaValue.trim().length < 6) {
      Swal.fire({
        title: 'Failed to post',
        text: 'Content should be atleast 6 characters long',
        icon: 'error',
        confirmButtonText: 'Close'
      });
      setWaiting(false);
      setParentFeed(null);
      return;
    }
    formData.append('content', textareaValue.trim());

    if (parseInt(sessionStorage.getItem("user_id"), 10)===1) {
      formData.append('icon', Math.floor(Math.random() * 8) + 1);
    } else {
      formData.append('icon', parseInt(sessionStorage.getItem("icon"), 10));
    }
    
    if (parent_feed !== null) {
      formData.append('parent_feed_id', parent_feed.id)
    }

    try {
      const response = await fetch(`${serverHost}/feed`, {
        method: 'POST',
        body: formData,
      });      
      const result = await response.json();

      if (response.status === 200) {
        setTextareaValue('');
        setEmojiVisibility(false);
        setImageFile(null);
        fetchFeeds();
      } else {
        Swal.fire({
          title: 'Failed to post',
          text: result.error,
          icon: 'error',
          confirmButtonText: 'Close'
        });
      }
    } catch (error) {
      Swal.fire({
        title: 'Failed to post',
        text: error,
        icon: 'error',
        confirmButtonText: 'Close'
      });
    }
    setWaiting(false);
    setParentFeed(null);
  }

  const voteFeed = async (feed_id, vote) => {
    const formData = new FormData();
    
    formData.append('feed_id', feed_id)
    formData.append('vote', vote)
    formData.append('user_id', user_id)

    try {
      const response = await fetch(`${serverHost}/feed/vote`, {
        method: 'POST',
        body: formData,
      });      
      const result = await response.json();

      if (response.status === 200) {
        setEmojiVisibility(false);
        fetchFeeds();
      } else {
        Swal.fire({
          title: 'Failed to vote feed',
          text: result.error,
          icon: 'error',
          confirmButtonText: 'Close'
        });
      }
    } catch (error) {
      Swal.fire({
        title: 'Failed to vote feed',
        text: error,
        icon: 'error',
        confirmButtonText: 'Close'
      });
    }
  }

  const renderContent = (content) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const imageRegex = /<image>(.*?)<\/image>/g;

    let parsedContent = content.replace(urlRegex, '<br><a href="$&" target="_blank" rel="noopener noreferrer">$&</a><br>');
    parsedContent = parsedContent.replace(imageRegex, '<br><img src="$1" /><br>');

      return { __html: parsedContent };
  }

  const removeFriend = (friendBody) => {
    Swal.fire({
      title: 'Remove Friend',
      text: `Are you sure about removing ${friendBody.name} as a friend?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
  
        formData.append('user_id', parseInt(sessionStorage.getItem("user_id"), 10));
        formData.append('friend_id', friendBody.id);

        try {
          const response = await fetch(`${serverHost}/remove-friend`, {
            method: 'POST',
            body: formData,
          });

          const result = await response.json();

          if (response.status === 200) {
            const updatedFriends = friends.filter(friend => friend.id !== friendBody.id);
            setFriends(updatedFriends);
            Swal.fire({
              title: 'Friend Removed',
              icon: 'success',
              confirmButtonText: 'Close'
            });
          } else {
            Swal.fire({
              title: 'Failed to remove friend',
              text: result.error,
              icon: 'error',
              confirmButtonText: 'Close'
            });
          }
        } catch (error) {
          console.error('Error removing friend:', error);
        }
      }
    });
  };

  const pokeFriend = async (friend) => {
    const formData = new FormData();
    
    formData.append('friend_id', friend.id)
    formData.append('user_id', user_id)

    try {
      const response = await fetch(`${serverHost}/poke-friend`, {
        method: 'POST',
        body: formData,
      });      
      const result = await response.json();

      if (response.status === 200) {
        Swal.fire({
          title: 'Request Sent',
          text: `${friend.name} has been requested to come online`,
          icon: 'success',
          confirmButtonText: 'Close'
        });
      } else {
        Swal.fire({
          title: 'Failed to notify user',
          text: result.error,
          icon: 'error',
          confirmButtonText: 'Close'
        });
      }
    } catch (error) {
      Swal.fire({
        title: 'Failed to notify user',
        text: error,
        icon: 'error',
        confirmButtonText: 'Close'
      });
    }
  };

  return (
    <>
      <Navbar />
      <Container>
        {/* Status Section */}
        <StatusSection visible={currentSection === 1}>
          <Label>
            <span>
              <i className="fa fa-comments" /> Bakar
            </span>
          </Label>
          <PostList>
            {feeds.map((feed) => (
              <Feed key={feed.id} feed={feed} voteFeed={voteFeed} />
            ))}
          </PostList>
          {isEmojiVisible && (
            <EmojiPicker
              onEmojiClick={addEmoji}
              skinTonesDisabled={true}
              style={{ position: 'absolute', bottom: '10%', left: '15px' }}
            />
          )}
          <CreatePost replyVisible={parent_feed ? true : false}>
            {/* <img src="images/smile.png" alt="emoji" onClick={openCloseEmoji} style={{ cursor: 'pointer' }} /> */}
            <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
              <label htmlFor="imageInput" style={{ display: imageFile ? 'none': 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '200%', color: 'grey', cursor: 'pointer' }}>
                <FontAwesomeIcon icon={faImages} />
              </label>
              <input type="file" id="imageInput" name="image" style={{ display: 'none' }} accept="image/*" onChange={handleImageChange} />
              <label htmlFor="imageInput" style={{ cursor: 'pointer' }}>
                <img src={imageFile} alt="Preview" style={{ display: !imageFile ? 'none': 'block', cursor: 'pointer', borderRadius: '50%' }} />
              </label>
              <span style={{ position: 'absolute', display: imageFile ? 'block': 'none', top: '-5px', right: '-5px', fontSize: '10px', cursor: 'pointer' }} onClick={() => setImageFile(null)}>❌</span>
            </div>
            <TextArea>
              {parent_feed && 
                <ReplyBar>
                  <p>
                    Reply: {parent_feed.content.replace(/<image>.*?<\/image>/gs, "🖼️")}
                  </p>
                  <span style={{ cursor: "pointer" }} onClick={() => setParentFeed(null)}>⨯</span>
                </ReplyBar>              
              }
              <textarea
                value={textareaValue}
                onKeyDown={handleKeyDown}
                onChange={(e) => setTextareaValue(e.target.value)}
                onFocus={() => setEmojiVisibility(false)}
                autoComplete="off"
                ref={postTextAreaRef}
              />
            </TextArea>
            <button onClick={handleFeedPost} disabled={waiting}>
              {waiting ? <i className='fa fa-spinner' /> : 'Post'}
            </button>
          </CreatePost>
        </StatusSection>

        <DownloadSection style={{ display: "none" }} visible={currentSection === 2}>
          <Heading>
            <h4>Stay connected with KGP 🚀</h4>
            <span>Download our Progressive Web App</span>
          </Heading>
          <Content>
            <img style={{ width: "15vw" }} src="images/connectkgp.png" alt="connectkgp" />
            <AppInfo>
              <h4>ConnectKGP</h4>
              <Rating
                initialRating={avgRating? avgRating:5}
                style={{ fontSize: "8px" }}
                readonly={true}
                emptySymbol={<StarIcon className="fa fa-star-o fa-2x" />}
                fullSymbol={<StarIcon filled className="fa fa-star fa-2x" />}
              />
            </AppInfo>
            <img style={{ float: "right" }} src="images/download.png" alt="download icon" onClick={openPopup} />
          </Content>
        </DownloadSection>
        {isPopupVisible && <DownloadDialogue onClose={closePopup} />}

        {/* Chat Section */}
        <ChatSection visible={currentSection === 2}>
          <Label>
            <span>Got a story to share?</span>
          </Label>
          <span><i className="fa fa-bullhorn" /> Share it with the world<br />At your own terms<br />with <b>Complete Anonymity</b> 🎭</span>
          {activeUsersCount > 0 && (
            <p style={{ textAlign: "center", margin: "10px 0 0 0" }}>
              Yayy! <b>{activeUsersCount}</b> {activeUsersCount > 1 ? 'users' : 'user'} active 🥳
            </p>
          )}
          <ImageContainer>
            <img src="images/call.png" alt="OTP Icon" />
          </ImageContainer>
          <select value={chatType} onChange={handleChatTypeChange}>
            <option value="text">Text Chat 💬</option>
            <option value="voice">Voice Chat 🎙️</option>
          </select>
          <button onClick={navigateChat}>Proceed</button>
          {/* <img src="images/secure.png" alt="secured chat" /> */}
        </ChatSection>        

        {/* Friends Section */}
        <FriendsSection visible={currentSection === 3}>
          <Label>
            <span><i className='fa fa-users' /> Your Friends</span>
          </Label>
          <FriendList>
            {friends.length > 0 ? (
              friends.map((friend) => (
                <Friend key={friend.id}>
                  <Info>
                    <img style={{ height: '24px', borderRadius: '50%' }} src={`avatars/${friend.icon}.png`} alt="user img" />
                    <span style={{ margin: '0 10px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{friend.name}</span>
                    <p style={{ fontSize: "12px", margin: "0", color: 'grey' }}>{moment(friend.last_active).fromNow()}</p>
                  </Info>
                  <Action>
                    <FontAwesomeIcon style={{ fontSize: '18px', cursor: 'pointer' }} icon={faBell} onClick={() => pokeFriend(friend)} />
                    <img style={{ height: '16px', marginLeft: '10px' }} src="images/remove-user.png" alt="remove friend" onClick={() => removeFriend(friend)} />
                  </Action>
                </Friend>
              ))
            ) : (
              <p>Oops! So empty 😶‍🌫️</p>
            )}
          </FriendList>
          <hr/>
          <Invitation>
            <span>It's more fun with <strong style={{ color: '#6559a2', fontStyle: 'italic' }}>Friends</strong></span>
            <ImageContainer style={{ marginTop: '10px' }}>
              <img src="images/invite.png" alt="send icon" />
            </ImageContainer>
            <span>Invite your friends <b style={{ color: '#6559a2', fontStyle: 'italic' }}>Now!!</b></span>
            <InvitationForm onSubmit={handleInvite}>
              <Input
                type="email"
                placeholder="Email"
                value={inviteEmail}
                onChange={(e) => setInviteEmail(e.target.value)}
                required
                autoComplete="off"
              />
              <button type='submit' style={{ background: "transparent", border: 'none', padding: '0', cursor: waiting ? 'not-allowed' : 'pointer' }} disabled={waiting} >
                {(waiting && inviteEmail!== '') ? <i className='fa fa-spinner' style={{ fontSize: '22px' }}/> : <img src='images/invite.svg' alt="send icon" style={{ height: "32px" }}/>}
              </button>
            </InvitationForm>
            <span style={{ verticalAlign: 'middle' }}>OR&nbsp;&nbsp;<a href='https://wa.me/?text=Yayy🤗 %0D%0AYou have been invited to *ConnectKGP* %0D%0A_KGP ka apna pseudonymous social network_ %0D%0ATry Now👇 %0D%0Ahttps://connectkgp.netlify.app' target="_blank" rel="noreferrer" style={{ textDecoration: 'none', color: '#25D36E' }}><b>Whatsapp</b>&nbsp;<i className='fa fa-whatsapp' style={{ fontSize: '16px', color: '#25D366' }}/></a></span>
          </Invitation>
        </FriendsSection>
      </Container>
      <PromotionSection onClick={() => navigate('/legend-of-kgp')}>
        <img src='images/mapwars.png' alt="Legend of KGP Game" />
      </PromotionSection>
      <NavigationBar style={{ display: "none", fontSize: '12px' }}>
        <Section>
          <NavButton onClick={() => navigate('/legend-of-kgp')} style={{ color: 'lightgrey' }}>
              <i className='fa fa-map' />
              Play
          </NavButton>
        </Section>
        <Section>
          <NavButton onClick={() => setCurrentSection(1)} style={{ color: currentSection === 1 ? 'white' : 'lightgrey' }}>
              <i className='fa fa-comments' />
              Feed
          </NavButton>
        </Section>
        <Section>
          <NavButton onClick={() => setCurrentSection(2)} style={{ color: currentSection === 2 ? 'white' : 'lightgrey' }}>
            <i className='fa fa-bullhorn' />
            Chat
          </NavButton>
        </Section>
        <Section>
          <NavButton onClick={() => setCurrentSection(3)} style={{ color: currentSection === 3 ? 'white' : 'lightgrey' }}>
            <i className='fa fa-users' />
            Friends
          </NavButton>
        </Section>
      </NavigationBar>
    </>
  );
};

export default Dashboard;

// Styled Components
const Container = styled.main`
  display: flex;
  align-items: center;
  height: 86vh;
  background-color: white;
  justify-content: space-around;

  @media only screen and (max-width: 600px) {
    height: 88vh;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
    overflow-y: hidden;
    padding: 20px 0;
  }
`;

const StatusSection = styled.div`
  height: auto;
  width: 25vw;
  border-radius: 5px;
  background: rgba(217, 217, 217, 0.5);
  box-shadow: rgba(0, 0, 0, 0.2) -5px 5px 0px;
  position: relative;

  @media only screen and (max-width: 600px) {
    width: 90vw;
    display: ${(props) => props.visible ? 'block' : 'none'};
  }
`;

const ChatSection = styled.div`
  height: auto;
  width: 20vw;
  border-radius: 5px;
  background: rgba(217, 217, 217, 0.5);
  box-shadow: rgba(0, 0, 0, 0.2) -5px 5px 0px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  select {
    width: 80%;
    // margin-top: 5%;
    margin-bottom: 10px;
    padding: 5px 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background: white;
  }

  button {
    background-color: #6559a2;
    padding: 10px 25px;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    margin-bottom: 5%;
    width: 80%;
    box-shadow: rgba(0, 0, 0, 0.2) -3px 3px 0px;
  }
  
  span {
    b {
      color: #6559a2;
      font-style: italic;
    }
  }

  @media only screen and (max-width: 600px) {
    width: 90vw;
    display: ${(props) => props.visible ? 'block' : 'none'};
  }
`;

const FriendsSection = styled.div`
  width: 20vw;
  border-radius: 5px;
  background: rgba(217, 217, 217, 0.5);
  box-shadow: rgba(0, 0, 0, 0.2) -5px 5px 0px;
  padding: 10px;

  span {
    margin-top: 4%;
  }

  @media only screen and (max-width: 600px) {
    width: 90vw;
    display: ${(props) => props.visible ? 'block' : 'none'};
  }
`;

const Label = styled.div`
  text-align: center;
  padding: 2%;
  display: flex;
  justify-content: center;

  span {
    font-size: 26px;
    color: #6559A2;
    font-weight: bold;
  }
`;

const FriendList = styled.div`
  margin: 10px 0;
  max-height: 50vh;
  overflow-y: auto;
  text-align: center;
`;

const Friend = styled.div`
  margin: 5px;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-around;
`;

const Info = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  width: 80%;
`;

const PostList = styled.div`
  padding: 10px;
  margin: 0 8px;
  background: white;
  border-radius: 5px;
  min-height: 20vh;
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;

  @media only screen and (max-width: 600px) {
    max-height: 68vh;
  }
`;

const CreatePost = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 2% 2%;
  background: transparent;
  align-items: center;
  gap: 10px;

  img {
    height: 50px;
    border: 1px solid rgb(118, 118, 118);
  }

  textarea {
    height: ${props => (props.replyVisible ? '40px' : '60px')};
    border-radius: 0px;    
    width: 100%;
    font-size: 12px;
    padding: 5px;
    vertical-align: middle;
  }

  button {
    background-color: #6559a2;
    padding: 20px;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    box-shadow: rgba(0, 0, 0, 0.2) -3px 3px 0px;

    i {
      animation: rotation 2s infinite linear;
    }
  
    @keyframes rotation {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(359deg);
      }
    }
  }
`;

const Action = styled.div`
  img {
    cursor: pointer;
  }
`;

const Post = styled.div`
  margin: 10px 0px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  // padding: 0 10px;
`;

const Options = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0px 10px;
  gap: 10px;
  padding: 0 5px;
`;

const PostBody = styled.div`
  background: #d6d6d6;
  border-radius: 0 8px 8px 8px;
  margin-left: 10px;
  max-width: 70%;

  p {
    white-space: pre-line;
    overflow: hidden;
    max-width: 400px;
    word-wrap: break-word;
    margin: 2px 10px;
    padding: 5px;
    background: transparent;

    img {
      border-radius: 5px;
    }
  }

  @media only screen and (max-width: 600px) {
    max-width: 65%;
  }
`;

const Author = styled.div``;

const Reactions = styled.div`
  margin-left: 10px;
  display: flex;
  gap: 5px;

  i {
    cursor: pointer;
  }

  i:hover {
    scale: 1.2;
  }

  span {
    margin: 0 2px;
    font-weight: bold;
  }
`;

const TextArea = styled.div`
  width: 75%;
  height: 60px;
`;

const ReplyBar = styled.div`
  display: flex;
  justify-content: space-between;
  background: rgb(101, 89, 162, 1);
  padding: 0 5px;
  color: white;
  overflow: hidden;

  p {
    margin: 0;
    overflow: hidden;
    max-width: 80%; 
    max-height: 20px;
    line-height: 20px;
  }
`;

const Children = styled.div`
  margin-left: 30px;
`

const ImageContainer = styled.div`
  text-align: center;
  background: transparent;
  padding: 0 20px;
  
  img {
    background: transparent;
  }
`;

const DownloadSection = styled.div`
  background: #6559a2;
  width: 90vw;
  border-radius: 5px;
  padding: 5px 10px;
  rgba(0, 0, 0, 0.1) 0px 0px 10px;
  color: white;

  @media only screen and (max-width: 600px) {
    display: ${(props) => props.visible ? 'block' : 'none'} !important;
  }
`;

const Heading = styled.div`
  text-align: center;

  h4 {
    margin: 0;
  }

  span {
    font-size: 14px;
  }
`;

const Content = styled.div`
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  img {
  }
  
  h4 {
    margin: 0 0;
  }
`;

const AppInfo = styled.div`
  width: 60%;
  text-align: left;
`;

const StarIcon = styled.i`
  color: ${({ filled }) => (filled ? 'gold' : 'grey')};
  margin-left: 2px;
`;

const Invitation = styled.div`
  text-align: center;
  margin: 10px;
`;

const InvitationForm = styled.form`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  gap: 10px;

  @media only screen and (max-width: 600px) {
    input {
      width: 80%;
    }
  }

  button {
    i {
      animation: rotation 2s infinite linear;
    }
  
    @keyframes rotation {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(359deg);
      }
    }
  }
`;

const Input = styled.input`
  height: 32px;
  padding: 0 5px;
`;

const NavigationBar = styled.div`
  @media only screen and (max-width: 600px) {
    background: #6559a2;
    justify-content: space-around;
    height: 6vh;
    padding: 0 10px;
    align-items: center;
    display: flex !important;
  }
`;

const Section = styled.div``;

const NavButton = styled.div`
  color: white;
  display: flex;
  gap: 2px;
  flex-direction: column;
  align-items: center;

  i {
    font-size: 22px;
  }
`;

const PromotionSection = styled.div`
  position: fixed;
  bottom: 3%;
  right: 3%;
  z-index: 99999;
  cursor: pointer;
  width: 200px;
  height: 200px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px;

  @media only screen and (max-width: 600px) {
    display: none;
  }
`;